<ng-container [formGroup]="jobForm">
    @if (appearance === 'onboarding') {
    <div class="fields-grid">
        <div class="field">
            <div class="field-label">
                <span translate>ai-exam-onboarding.professional-universe.field.job</span>
                <span class="required">*</span>
            </div>
            <input
                type="text"
                class="onboarding-input"
                formControlName="job"
                autocomplete="off"
                [placeholder]="'ai-exam-onboarding.professional-universe.field.job-placeholder' | translate" />
        </div>

        <div class="field">
            <div class="field-label">
                <span translate>ai-exam-onboarding.professional-universe.field.sector</span>
                <span class="required">*</span>
            </div>
            <input
                type="text"
                class="onboarding-input"
                formControlName="business"
                autocomplete="off"
                [placeholder]="'ai-exam-onboarding.professional-universe.field.sector-placeholder' | translate" />
        </div>
    </div>
    } @else {
    <div class="md:grid md:grid-cols-2 items-center justify-center">
        <mat-form-field class="w-full">
            <mat-label><span translate>ai-no-user-votre-emploi</span></mat-label>
            <input matInput placeholder="Entrez votre emploi" formControlName="job">
        </mat-form-field>
        <mat-error *ngIf="jobForm.touched && jobForm.get('job')?.errors?.required">
            Ce champ est obligatoire
        </mat-error>
    </div>

    <div class="md:grid md:grid-cols-2 items-center justify-center">
        <mat-form-field class="w-full">
            <mat-label><span translate>ai-no-user-votre-secteur</span></mat-label>
            <input matInput placeholder="Entrez votre secteur d'activité" formControlName="business">
        </mat-form-field>
        <mat-error *ngIf="jobForm.touched && jobForm.get('business')?.errors?.required">
            Ce champ est obligatoire
        </mat-error>
    </div>
    }
</ng-container>
